//src/design-system/Organisms/TestimonialSection/TestimonialTabShimmer.tsx
import { ShimmerEffect } from "@/design-system/Atoms";

const TestimonialTabShimmer = () => {
  return (
    <div className="relative flex flex-col w-[75%] mx-auto mt-6 rounded-2xl backdrop-blur-md bg-white p-6 ">
      <div>
        <ShimmerEffect className="h-[108px] w-full mb-10" />
        <ShimmerEffect className="h-[54px] w-full mb-4 mt-0" />
        <ShimmerEffect className="h-[27px] w-14 lg:w-28 mt-12" />
      </div>

      <div className="relative flex lg:flex py-4 mt-6 mb-1 justify-between items-center">
        <div className="flex gap-7">
          <ShimmerEffect className="h-[60px] w-[80px] lg:w-[80px]" />
          <ShimmerEffect className="h-[60px] w-[80px] lg:w-[80px]" />
        </div>
      </div>
    </div>
  );
};

export default TestimonialTabShimmer;
